// styles.ts
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors, FontWeight } from '../../../../assets/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  table: {
    marginBottom: 80,
    marginTop: 30,
  },
  tableContainer:{
    backgroundColor: 'white', 
    borderRadius:'5px',
    marginBottom:'20px'
  },
  columnTitle: {
    fontSize: '16px !important',
    fontWeight: FontWeight.Light,
    color: Colors.Black,
    padding: '12px',
  },
   tableHead:{
      fontWeight:FontWeight.Bold,
      fontSize:'16px',
      color:'black',
      border:`1px solid ${Colors.Gray1}`
    },
  sectionTitle: {
    color: Colors.Blue,
    fontSize: 16,
    fontWeight: FontWeight.Light,
    padding: '12px',
  },
  subsectionTitle: {
    color: Colors.Blue,
    fontSize: 14,
    fontWeight: FontWeight.Light,
    backgroundColor: 'rgba(204,204,204,0.1)',
    paddingLeft: 76,
    padding: '12px',
  },
  sectionAmount: {
    width: '25%',
    color: `${Colors.Gray} !important`,
    fontSize: '14px !important',
    padding: '12px',
  },
  subsectionAmount: {
    width: '25%',
    color: Colors.Gray,
    fontSize: 14,
    backgroundColor: 'rgba(204,204,204,0.1)',
    padding: '12px',
  },
  contentTitle: {
     marginBottom: '24px !important',
    marginTop: 24,
  },
}));

export const useTableCellStyles = makeStyles((theme: Theme) => ({
  root: {
    '&.MuiTable-root':{
      border: `1px solid ${Colors.Gray5}`,
    },
  },
  cell:{
    '&.MuiTableCell-root':{
      border: `1px solid ${Colors.Gray5}`,
    }
  },
}));